import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";

export const WelcomePage = () => {
    const isWelcomePage = $("#page-welcome").length > 0;
    if (!isWelcomePage) return false;

    if (sessionStorage.getItem('is-watched-tutorial')) {
        sessionStorage.removeItem('is-watched-tutorial');
    }

    bdjs.hideLoading();

    const onInputTeamID = function (e, keepError) {
        if (keepError) return;

        const isDisabled = String($(this).val()).trim().length < 1;

        $(".js-join-btn").prop("disabled", isDisabled);
        $(".welcome__code").removeClass("incorrect");
    };

    let isLoading = false;
    const onSubmitTeamID = async function () {
        if (isLoading) return false;
        const $joinBtn = $(".js-join-btn");
        const $inputTeamCode = $(".js-team-id");

        $(".welcome__code").addClass("loading");
        $joinBtn.prop("disabled", true);
        $inputTeamCode.prop("readonly", true);
        $(".welcome__code").removeClass("incorrect");

        isLoading = true;

        const [res, err] = await bdjs.goAsync(
            bdapi.post("public/join-team", {
                team_code: $(".js-team-id").val(),
            }),
        );

        isLoading = false;
        const restData = res?.data || {};

        if (restData?.data?.redirect) {
            $(".welcome__code").removeClass("loading").addClass("success");

            setTimeout(() => {
                bdjs.showLoading();
                history.replaceState(null, "", window.location.href);
                window.location.replace(restData.data.redirect);
                return;
            }, 2000);
        }

        if (!restData?.success || err) {
            $(".welcome__code").removeClass("loading");
            $inputTeamCode.prop("readonly", false);
            $(".js-team-id").trigger("focus", { keepError: true });
            $(".welcome__code").addClass("incorrect");
            $(".welcome__code--incorrect").html(
                "<span>" + restData.data.message + "</span>",
            );
        }
    };

    $(".js-team-id").on("focus", onInputTeamID);
    $(".js-team-id").on("input", onInputTeamID);
    $(".js-join-btn").on("click", onSubmitTeamID);
};
